'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Validate = require('../Validation/Validate');

var _Validate2 = _interopRequireDefault(_Validate);

var _ChedioButtox = require('./ChedioButtox');

var _ChedioButtox2 = _interopRequireDefault(_ChedioButtox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckBox = function (_Component) {
  _inherits(CheckBox, _Component);

  function CheckBox() {
    _classCallCheck(this, CheckBox);

    return _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).apply(this, arguments));
  }

  _createClass(CheckBox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          children = _props.children,
          disabled = _props.disabled,
          error = _props.error,
          invalid = _props.invalid,
          name = _props.name,
          indeterminate = _props.indeterminate,
          patterns = _props.patterns,
          required = _props.required,
          rest = _objectWithoutProperties(_props, ['checked', 'children', 'disabled', 'error', 'invalid', 'name', 'indeterminate', 'patterns', 'required']);

      return _react2.default.createElement(
        _Validate2.default,
        {
          error: error,
          patterns: patterns,
          required: required,
          value: checked },
        function (isValid) {
          return _react2.default.createElement(
            _ChedioButtox2.default,
            _extends({}, rest, {
              checked: !!(checked || indeterminate),
              className: 'ax-checkbox',
              disabled: disabled,
              indeterminate: indeterminate && !checked,
              inputType: 'checkbox',
              invalid: invalid || isValid === false,
              name: name }),
            children
          );
        }
      );
    }
  }]);

  return CheckBox;
}(_react.Component);

CheckBox.propTypes = {
  /** Checked state of the input */
  checked: _propTypes2.default.bool,
  /** Label that is placed next to the input */
  children: _propTypes2.default.node,
  /** Disables interactions and applies styling */
  disabled: _propTypes2.default.bool,
  /** See Validate[error] */
  error: _propTypes2.default.func,
  /** Partially checked state of the input */
  indeterminate: _propTypes2.default.bool,
  /** Applies styling to indicate the users input was invalid */
  invalid: _propTypes2.default.bool,
  /** Name of the group the input belongs to */
  name: _propTypes2.default.string,
  /** See Validate[patterns] */
  patterns: _propTypes2.default.array,
  /** See Validate[required] */
  required: _propTypes2.default.bool,
  /** Text that is displayed on hover */
  title: _propTypes2.default.string
};
exports.default = CheckBox;